import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/analytics')({
  component: AnalyticsLayout,
});

function AnalyticsLayout() {
  return <Outlet />;
}
